import gsap from 'gsap';

export const careersAnimation = () => {
	if (window.innerWidth < 1024) return;

	const careerCardsOdd = document.querySelectorAll('.career-card-odd');
	const careerCardsEven = document.querySelectorAll('.career-card-even');

	if (!careerCardsOdd.length || !careerCardsEven.length) return;

	careerCardsEven.forEach((element) => {
		gsap.fromTo(
			element,
			{ rotate: 0 },
			{
				rotate: -5,
				duration: 1.2,
				ease: 'smoothEasing',
				scrollTrigger: {
					trigger: element,
					start: 'top 80%',
					end: 'bottom 20%',
					toggleActions: 'play none none',
				},
			}
		);
	});

	careerCardsOdd.forEach((element) => {
		gsap.fromTo(
			element,
			{ rotate: 0 },
			{
				rotate: 5,
				duration: 1.2,
				ease: 'smoothEasing',
				scrollTrigger: {
					trigger: element,
					start: 'top 80%',
					end: 'bottom 20%',
					toggleActions: 'play none none',
				},
			}
		);
	});
};
